module.exports = __webpack_public_path__ + "static/img/detectionPoint.077a749.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/detectionPoint.png
// module id = /Uu4
// module chunks = 37